module.exports = __webpack_public_path__ + "img/photo-25.0ed897d8.jpg";